import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Zähler-Badge (Seitenleiste, Tabs). Gelb = „bitte ansehen“, Rot = dringend.
 *
 * Mit `reserve` bleibt der Platz auch bei 0 oder fehlendem Wert belegt (unsichtbarer
 * Platzhalter), damit nichts springt, wenn der Wert nachkommt (#1400).
 * In einer aktiven Seitenleisten-Zeile (`a.active`) wird es automatisch weiß.
 */
@Component({
  selector: 'app-count-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (visible() || reserve()) {
      <span class="badge" [class.yellow]="tone() === 'yellow'" [class.placeholder]="!visible()"
        [attr.aria-hidden]="visible() ? null : 'true'">{{ shown() }}</span>
    }
  `,
  styles: `
    :host {
      display: inline-flex;
    }
    .badge {
      box-sizing: border-box;
      min-width: 1.875rem;
      padding: 0.0625rem 0.4375rem;
      border-radius: 0.625rem;
      text-align: center;
      font-size: 0.6875rem;
      font-weight: 500;
      line-height: 1.25;
      background: var(--theme-warn, #e2382a);
      color: var(--theme-warn-contrast, #fff);
    }
    .badge.yellow {
      background: #f0b400;
      color: #1f1f1f;
    }
    .badge.placeholder {
      visibility: hidden;
    }
    :host-context(a.active) .badge {
      background: #fff;
      color: var(--theme-warn, #e2382a);
    }
    :host-context(a.active) .badge.yellow {
      background: #fff;
      color: #8a6500;
    }
  `,
})
export class CountBadgeComponent {
  readonly count = input<number | null | undefined>(0);
  readonly tone = input<'red' | 'yellow'>('red');
  /** Platz auch ohne Wert freihalten. */
  readonly reserve = input(false);

  protected readonly visible = computed(() => (this.count() ?? 0) > 0);
  protected readonly shown = computed(() => (this.visible() ? this.count() : 0));
}
